import { createSlice } from '@reduxjs/toolkit';

const formSlice = createSlice({
    name: 'formPromoter',
    initialState: {
        pendingPromoterForms: [],
    },
    reducers: {
        addPendingPromoterForm(state, action) {
            console.log('formPromoterReducer: ', action.payload)
            state.pendingPromoterForms.push(action.payload);
        },
        clearPendingPromoterForms(state) {
            state.pendingPromoterForms = [];
        },
    },
});

export const { addPendingPromoterForm, clearPendingPromoterForms } = formSlice.actions;
export default formSlice.reducer;